import request from "@/utils/request";

export function getInfo() {
  return request({
    url: "/user/token.do",
    method: "post"
  });
}
export function getUserByToken() {
  return request({
    url: "/userInfo/getByToken",
    method: "post"
  });
}
